import script from "./Gartenkultur-Ext-Team.vue?vue&type=script&setup=true&lang=js"
export * from "./Gartenkultur-Ext-Team.vue?vue&type=script&setup=true&lang=js"

import "./Gartenkultur-Ext-Team.vue?vue&type=style&index=0&id=fe25b006&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe25b006"]])

export default __exports__